import React from "react";

const EditMyAccount = () => {
  return (
    <div className="container">
      <p>Edit My Account</p>
    </div>
  );
};

export default EditMyAccount;